'use strict';

var _ = require('lodash');
var GridToolbarConfigurationBudgetTargetController = function GridToolbarConfigurationBudgetTargetController($scope, toolbarGridService) {
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDuplicateButtonShown = selectedRows.length === 1;
    $scope.isDeleteButtonShown = selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  };
  function setStructureWithOldValues(loadedData, rowid) {
    loadedData[rowid]._old = {};
    var columns = $scope.jqxGridSettings.columns;
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  $scope.addBudgetTarget = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({
      isNewlyAdded: true
    });
    setStructureWithOldValues(loadedData, 0);
    $scope.updateData(loadedData);
  };
  $scope.removeBudgetTarget = function () {
    toolbarGridService.removeRow($scope);
  };
  $scope.duplicateBudgetTarget = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndex = $scope.jqxGridSettings.jqxGrid('getselectedrowindex');
    var rowid = $scope.jqxGridSettings.jqxGrid('getrowid', selectedIndex);
    var oldRow = loadedData[rowid];
    var newRow = _.clone(oldRow);
    loadedData.splice(rowid, 0, newRow);
    setStructureWithOldValues(loadedData, rowid);
    $scope.updateData(loadedData);
  };
  $scope.saveChanges = function () {
    var rows = _.chain($scope.jqxGridSettings.source.loadedData).clone(true).map(function (row) {
      delete row.originalRowId;
      return row;
    }).value(true);
    $scope.$emit('configuration-budget-target:saveChanges', rows);
  };
  $scope.$on('configuration-budget-target:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
};
GridToolbarConfigurationBudgetTargetController.$inject = ['$scope', 'ToolbarGridService'];
module.exports = GridToolbarConfigurationBudgetTargetController;